import { NgxLoggerLevel } from 'ngx-logging-kit';
import { ENV, Urls } from '@core/config/urls';

export const environment: ENV = {
	production: false,
	baseURL: Urls.Dynamic,
	applicationId: 'SMARTY-CUBE',
	loggerConfig: {
		level: NgxLoggerLevel.DEBUG,
		timestampFormat: 'HH:mm:ss',
	},
	i18n: {
		languages: ['en', 'tr'],
		defaultLanguage: 'tr',
	},
	Oauth2: {
		CLIENT_SECRET: '123456',
		CLIENT_ID: 'smarty-cube',
	},
	demo: false,
	smartyGpt: true,
};

console.log('dev: ', environment);
